import { TemplateService } from 'src/app/web-generator/template-generator/service/template.service';
import { BehaviorSubject, Observable, ReplaySubject, timer } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { map, publishLast, refCount } from 'rxjs/operators';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from '../../web-generator/generator-env-token';
import { isPlatformBrowser } from '@angular/common';
import { ServerConfigService } from './server-config.service';
/** ITRI 熱門關鍵字 API */
@Injectable({
  providedIn: 'root'
})
export class HotKeywordsService {
  /** 是否為瀏覽器端渲染 */
  isBrowser: boolean;
  /** 取熱門關鍵字 */
  private _hotKeyWords$ = new BehaviorSubject<string[]>(undefined);
  /** 取熱門關鍵字 API */
  private _hotKeyWordsApi$: Observable<string[]>;
  get hotKeyWords$() {
    if (this.hotKeyWords) { return this._hotKeyWords$; } else { return this._hotKeyWordsApi$; }
   }
  /** 熱門關鍵字 */
  get hotKeyWords() {
    return this._hotKeyWords$.value;
  }
  /** 查過的關鍵字 */
  records: string[] = [];
  /** 取查過的關鍵字 */
  records$ = new ReplaySubject<string[]>();

  constructor(
    @Inject(GENERATOR_ENV_TOKEN) private generatorEnv: GeneratorEnv,
    @Inject(PLATFORM_ID) protected platformId: object,
    private serverConfigService: ServerConfigService,
    private http: HttpClient,
    private templateService: TemplateService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (this.isBrowser) {
      const keywordRecords = sessionStorage.getItem('keywordRecords');
      if (keywordRecords) {
        this.records = JSON.parse(keywordRecords);
        this.records$.next(this.records);
      }
    }

    this._hotKeyWordsApi$ = this.templateService.siteInfo$.pipe(
      map(siteInfo => siteInfo.keywords)
    );
  }

  /** 記錄我(這次拜訪網站)查過的關鍵字(，包含進網站url上帶的關鍵字) */
  record(keyword: string) {
    if (!this.records.find(r => r === keyword)) {
      this.records.push(keyword);
      const newRecs = JSON.parse(JSON.stringify(this.records));
      this.records$.next(newRecs);
      if (this.isBrowser) {
        sessionStorage.setItem('keywordRecords', JSON.stringify(newRecs));
      }
    }
    this.http.post<string>(`${this.generatorEnv.apiHost}/api/site/${this.serverConfigService.config.lang}/keyword`, {}, {
      params: {
        word: keyword,
      }
    }).subscribe();
  }
}
